import styled from 'styled-components'
import {Popover} from 'react-bootstrap'

const injectColor = ({isOrderActive}) => (isOrderActive ? '#1E7BE1' : '#383838')

export const OrderContainer = styled.div`
  color: ${injectColor};
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  i {
    color: ${injectColor};
    font-size: 10px;
  }
  i.inactive {
    color: #ddd;
    font-size: 10px;
  }
  span {
    margin-right: 5px;
  }
`

export const ActionIcon = styled.i`
  color: #1e7be1;
  cursor: pointer;
`

export const StyledPopover = styled(Popover)`
  max-height: 300px;
  overflow-y: scroll;
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
`
